module.exports = __webpack_public_path__ + "img/c4.9a19f2af.png";